export default {
    search: {
        filters: {
            grade: '',
            section: '',
        },
        grades: [],
        sections: []
    }
}